export default "__VITE_ASSET__DpG0xNqR__"